import {Injectable} from '@angular/core';
import {BaseProductConfig, SupportedLanguage} from '@scalified-monorepo/ng-shared';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  {code: 'en', name: 'English'},
  {code: 'ua', name: 'Українська'},
];

@Injectable()
export class ProductConfigService implements BaseProductConfig {
  name = 'Frontend Sample';
  domain = 'forntend-sample.com';
  initialProtectedRoute = '/admin';
  redirectOnAuthRoutes = ['login', 'signup'];
  supportedLanguages = SUPPORTED_LANGUAGES;
}
